import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useCargosListaFilters
 */

type State = {
  nome: string;
  atribuicoes: string;
  escolaridade: string;
  status: number;
};

type Action = {
  setNome: (nome: string) => void;
  setAtribuicoes: (atribuicoes: string) => void;
  setEscolaridade: (escolaridade: string) => void;
  setStatus: (status: number) => void;
  clearFilters: () => void;
};

export const useCargosListaFilters = create<State & Action>((set) => ({
  nome: '',
  atribuicoes: '',
  escolaridade: '',
  status: 2,
  setNome: (nome) => set({ nome }),
  setAtribuicoes: (atribuicoes) => set({ atribuicoes }),
  setEscolaridade: (escolaridade) => set({ escolaridade }),
  setStatus: (status) => set({ status }),
  clearFilters: () => set({
    nome: '',
    atribuicoes: '',
    escolaridade: '',
    status: 2,
  }),
}));

export const initialFiltersValues: State = {
  nome: '',
  atribuicoes: '',
  escolaridade: '',
  status: 2,
}